import {
    ageRangeFieldConstructor,
    dropdownFieldConfigConstructor,
    rangeFieldConfigConstructor
} from "scenes/cohort-filters/filter-configs/fieldContructors";
import {Category} from "scenes/cohort-filters/filter-configs/categories";

export const generalFields = {
    ...dropdownFieldConfigConstructor({
        category: Category.GENERAL,
        pathToValue: "bio_sex",
        dropdownValues: [
            { value: "MAN", label: "global.male-bio-sex" },
            {
                value: "WOMAN",
                label: "global.female-bio-sex",
            },
        ],
        label: "anamnesis.general.genderLabel",
    }),
    ...rangeFieldConfigConstructor({
        category: Category.GENERAL,
        pathToValue: "anamnesis.height",
        label: "anamnesis.general.heightLabel",
        fieldWidth: 56,
    }),
    ...rangeFieldConfigConstructor({
        category: Category.GENERAL,
        pathToValue: "anamnesis.weight",
        label: "anamnesis.general.weightLabel",
        fieldWidth: 56,
    }),
    ...ageRangeFieldConstructor({
        pathToValue: "age",
        label: "global.age",
        category: Category.GENERAL,
        defaultFromValue: 18,
        defaultToValue: 40,
        fieldWidth: 56,
    }),
}
